<template>
    <div>
        <v-col cols="12">
            <button class="button back-to-list" @click="backToList">
                <v-icon>mdi-arrow-left</v-icon>
                <span class="text">Back To List</span>
            </button>
        </v-col>
        <v-col cols="12">
            <h2>{{ t('quality-control::title.upload_target_values') }}</h2>
        </v-col>
        <div>
            <v-col cols="12" class="py-0">
                <v-form ref="form" v-model="isValid">
                    <v-row>
                        <v-col cols="12" lg="4" md="6" class="upload-file">
                            <v-btn v-if="!horiba.file" rounded text color="primary" @click="triggerFileInput">
                                {{ t('patients::button.browse') }}
                            </v-btn>
                            <b-file-input
                                ref="fileInput"
                                to-mutate="qualityControl::horiba.file"
                                :label="t('quality-control::date.file')"
                                accept=".csv"
                                mandatory
                                class="file"
                                :prepend-icon="null"
                                :rules="validationRules.file"
                                @change="processFile"
                            ></b-file-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" lg="4" md="6" class="upload-file">
                            <b-input
                                to-mutate="qualityControl::horiba.activate_on"
                                :label="t('quality-control::date.activate_on')"
                                :hint="t('quality-control::horiba.upload_target_file.activate_on.hint')"
                                :persistent-hint="true"
                                disabled
                            ></b-input>
                        </v-col>
                        <v-col cols="12" lg="4" md="6" class="upload-file">
                            <b-input
                                to-mutate="qualityControl::horiba.expires_on"
                                :label="t('quality-control::date.expires_on')"
                                :hint="t('quality-control::horiba.upload_target_file.expires_on.hint')"
                                :persistent-hint="true"
                                disabled
                            ></b-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                :disabled="!isValid && !horiba.id"
                                color="primary"
                                rounded
                                :loading="horibaFormLoading"
                                large
                                class="mr-5"
                                @click="uploadFile()"
                            >
                                {{ t('quality-control::button.submit') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isValid: false,
            activate_date: false,
            expires_date: false,
            horibaFormLoading: false,
            validationRules: {
                file: [(v) => !!v || t('default::validation.field.csv_file')],
            },
        };
    },
    computed: {
        horiba() {
            return this.$store.state.qualityControl.horiba;
        },
    },
    methods: {
        triggerFileInput() {
            this.$refs.fileInput.$children[0].$refs.input.click();
        },

        backToList() {
            return this.$root.goTo(route('horiba.index'));
        },
        processFile(file) {
            if (!file) {
                return this.clearHoribaForm();
            }
            this.horibaFormLoading = true;
            const data = new FormData();
            data.append('file', file);
            return axios
                .post(route('api.v1.horiba.extract-dates'), data)
                .then((res) => {
                    const resData = _.clone(res.data.data);
                    const horiba = new Object();
                    horiba.id = resData.id;
                    horiba.file = file;
                    horiba.activate_on = resData.activate_on;
                    horiba.expires_on = resData.expires_on;
                    this.$store.dispatch('qualityControl/setHoriba', horiba);
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('qualityControl/setErrorMessages', error.response.data.errors);
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                    this.clearHoribaForm();
                })
                .finally(() => _.delay(() => (this.horibaFormLoading = false), 400));
        },
        clearHoribaForm() {
            const horiba = new Object();
            horiba.id = null;
            horiba.file = null;
            horiba.activate_on = null;
            horiba.expires_on = null;
            this.$store.dispatch('qualityControl/setHoriba', horiba);
        },
        uploadFile() {
            this.horibaFormLoading = true;
            return axios
                .put(route('api.v1.horiba.update', { horiba: this.horiba.id }))
                .then(() => {
                    this.backToList();
                })
                .catch((error) => {
                    this.$root.notify('error', error.response.data.error);
                })
                .finally(() => _.delay(() => (this.horibaFormLoading = false), 400));
        },
    },
};
</script>
